import { IStoreState } from 'modules/types';

export const getLoungeData = (state: IStoreState) => state.lounge.lounge;
